import { Component, Inject, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ExportFeaturesComponent } from "./export-features.component";
import { IDialogData } from "../../viewer-components/interfaces/i-dialog-data";

@Component({
  selector: "phoenix-export-features-component",
  templateUrl: "./export-features.component.html",
  styleUrls: ["./export-features.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class PhoenixExportFeaturesComponent extends ExportFeaturesComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: IDialogData) {
    super(data);
  }
}
